import { urlService } from '@whiz-cart/ui-shared/url/url.service';

/** Resolves with the selected `storeGuid` as soon as one is set. */
export async function awaitStoreGuid() {
    const url = await urlService.state.once((url) => url.params.storeGuid !== undefined);
    return url.params.storeGuid as string;
}
